export enum DocumentRefType {
  WORK_ORDER = 'WORK_ORDER',
  INCIDENT = 'INCIDENT',
  EXPENSE = 'EXPENSE',
  SEALING= 'SEALING',
  WEIGHING= 'WEIGHING',
  OTHER = 'OTHER'
}
